import { formatMoney } from "../utilities";

// Atualiza o preço dos produtos
export function updatePrice(data, element) {
  if (!data || !element) return;
  element.innerHTML = "";

  // Exibição padrão de produto com múltiplas variantes (sem seleção de atributos)
  let variant = data;
  if (data.variants && data.variants.length > 0) {
    // Define regra de preço
    const useMinPrice = true;
    const useMaxPrice = false;

    // Coleta variante de menor preço
    variant = data.variants[0];
    data.variants.forEach((v) => {
      if (
        v.available &&
        ((useMinPrice && v.price <= variant.price) ||
          (useMaxPrice && v.price >= variant.price))
      )
        variant = v;
    });
  }

  // Exibe informações de preço principal/bloco com base na disponibilidade da variante
  variant.available
    ? element.closest("[data-section-product]")
      ? updatePriceMain(variant, element)
      : updatePriceBlock(variant, element)
    : addUnavailable(data, element);

  if (variant.sku) element.setAttribute("data-sku-price", variant.sku);
  element.classList.add("-loaded");
}

// HTML de preço do produto principal
export function updatePriceMain(data, element) {
  // addPercentage(data, element);
  addPrice(data, element, "h2");

  if (window.language == "pt-BR") {
    addInstallments(data, element, "main");
    addPIX(data, element, "main");
  }

  // addCashback(data, element, 'main');
}

// HTML de preço dos blocos de produtos
export function updatePriceBlock(data, element) {
  addPrice(data, element, "p");

  if (window.language == "pt-BR") {
    addInstallments(data, element, "block");
    addPIX(data, element, "block");
  }
}

// Valor normal e remarcado
function addPrice(data, element, tag) {
  const newElement = document.createElement(tag);
  newElement.classList.add("price");

  if (data.on_sale) element.classList.add("-on-sale");

  newElement.innerHTML =
    window.language == "en"
      ? `<span>${formatMoney(data.intl_price)}</span>`
      : data.on_sale
        ? tag == "h2"
          ? `<ins>${formatMoney(data.sale_price)}</ins><del>${formatMoney(data.price)}</del>`
          : `<del>${formatMoney(data.price)}</del><ins>${formatMoney(data.sale_price)}</ins>`
        : `<span>${formatMoney(data.price)}</span>`;

  element.appendChild(newElement);
}

// Valor parcelado
function addInstallments(data, element, type) {
  if (!data.installments.length) return;

  let length = 0;
  data.installments.forEach((ins) => {
    if (!ins.interest) length++;
  });

  const newElement = document.createElement("p");
  newElement.classList.add("installments");
  newElement.innerHTML =
    type == "block"
      ? `ou ${length}x de ${formatMoney(data.installments[length - 1].price)}`
      : `ou ${length}x de ${formatMoney(data.installments[length - 1].price)}`;

  element.appendChild(newElement);
}

// Valor em PIX
function addPIX(data, element, type) {
  if (!pixDiscount) return;

  const newElement = document.createElement("p");
  newElement.classList.add("pix");
  // newElement.innerHTML =
  //   type == 'block'
  //     ? `${formatMoney(data.sale_price - (data.sale_price / 100 * pixDiscount))} no PIX`
  //     : `${formatMoney(data.sale_price - (data.sale_price / 100 * pixDiscount))} no PIX com ${pixDiscount}% de desconto`
  newElement.innerHTML = `${pixDiscount}% de desconto no PIX`;

  element.appendChild(newElement);
}

// Valor de cashback
function addCashback(data, element, type) {
  if (
    !data.cashback ||
    !data.cashback.percentage ||
    data.cashback.percentage == 0
  )
    return;

  const newElement = document.createElement("p");
  newElement.classList.add("cashback");
  newElement.innerHTML =
    type == "block"
      ? `${formatMoney((data.sale_price / 100) * data.cashback.percentage)} de cashback!`
      : `Ganhe até ${formatMoney((data.sale_price / 100) * data.cashback.percentage)} de cashback!`;

  element.appendChild(newElement);
}

// Valor de desconto em porcentagem
function addPercentage(data, element) {
  if (!data.on_sale) return;

  const newElement = document.createElement("p");
  newElement.classList.add("percentage");
  newElement.innerHTML = `${`${100 - (data.sale_price / data.price) * 100}`.split(".")[0]}% OFF`;

  element.appendChild(newElement);
}

// Valor Esgotado
function addUnavailable(data, element) {
  if (data.available) return;

  const newElement = document.createElement("p");
  newElement.classList.add("sold-out");
  newElement.innerHTML =
    window.language == "pt-BR" ? "Esgotado" : "Unavailable";

  element.appendChild(newElement);
}
